import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("demandai_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("demandai_token");
    if (token) {
      api.get("/auth/me").then((r) => {
        setUser(r.data);
        localStorage.setItem("demandai_user", JSON.stringify(r.data));
      }).catch(() => {});
    }
  }, []); // eslint-disable-line

  const login = async (email, password) => {
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      localStorage.setItem("demandai_token", r.data.token);
      localStorage.setItem("demandai_user", JSON.stringify(r.data.user));
      setUser(r.data.user);
      return r.data.user;
    } finally {
      setLoading(false);
    }
  };

  const signup = async (data) => {
    setLoading(true);
    try {
      const r = await api.post("/auth/signup", data);
      localStorage.setItem("demandai_token", r.data.token);
      localStorage.setItem("demandai_user", JSON.stringify(r.data.user));
      setUser(r.data.user);
      return r.data.user;
    } finally {
      setLoading(false);
    }
  };

  const refreshUser = async () => {
    try {
      const r = await api.get("/auth/me");
      localStorage.setItem("demandai_user", JSON.stringify(r.data));
      setUser(r.data);
      return r.data;
    } catch {
      return null;
    }
  };

  const logout = () => {
    localStorage.removeItem("demandai_token");
    localStorage.removeItem("demandai_user");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, signup, logout, refreshUser, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
